import { Field, FieldProps } from 'formik';
import { RadioGroupComponent, RadioOption } from '../RadioGroup';

interface FormikRadioGroupProps<T = string | boolean> {
  name: string;
  options: RadioOption<T>[];
  label?: string;
  required?: boolean;
  disabled?: boolean;
  direction?: 'horizontal' | 'vertical';
}

export const FormikRadioGroup = <T extends string | boolean = string | boolean>({
  name,
  options,
  label,
  required,
  disabled,
  direction
}: FormikRadioGroupProps<T>) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <RadioGroupComponent<T>
          value={field.value}
          onChange={value => form.setFieldValue(name, value)}
          options={options}
          disabled={disabled}
          label={label}
          required={required}
          name={name}
          direction={direction}
        />
      )}
    </Field>
  );
};
